import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import React, { Component } from 'react';
import { showError, showInfo } from '../../actions/notificationActions';

import ReactQuill from 'react-quill';
import { callApi } from '../../utils';
import { closeAllModals } from '../../actions/modalActions';
import { connect } from 'react-redux';
import { startCase } from 'lodash';

export default connect((state) => ({
  open: state.modals.editCareer,
  id: state.modals.data,
}))(
  class EditCareerModal extends Component {
    state = {
      loading: false,
      error: '',
      career: {
        title: '',
        status: '',
        team: '',
        excerpt: '',
        description: '',
      },
      title: '',
      status: '',
      team: '',
      statuses: ['Draft', 'Open', 'Closed'],
      teams: [
        'engineering',
        'customer_support',
        'marketing',
        'hr',
        'sales',
        'other',
      ],
      excerpt: '',
      description: '',
      errors: [],
    };

    componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open && this.props.open) {
        this.setState({
          loading: false,
          career: {},
        });
        this.loadCareer(this.props.id);
      }
    }

    loadCareer = (id) => {
      this.setState({ loading: true });

      callApi(`/careers/${id}`)
        .then((res) => {
          this.setState({
            loading: false,
            career: res.data,
          });
        })
        .catch((err) => {
          this.setState({ loading: false });
          this.props.dispatch(showError(err.message));
        });
    };

    setInput = (e) => {
      const { name, value } = e.target;
      this.setState((state) => {
        return { ...state, career: { ...state.career, [name]: value } };
      });
    };

    close = () => {
      this.props.dispatch(closeAllModals());
    };

    updateCareer = (e) => {
      e.preventDefault();
      this.setState({ loading: true });

      callApi(
        `/careers/${this.props.id}`,
        {
          title: this.state.career.title,
          team: this.state.career.team,
          status: this.state.career.status,
          description: this.state.career.description,
          excerpt: this.state.career.excerpt,
        },
        'patch'
      )
        .then(() => {
          this.setState({ loading: false });
          this.props.dispatch(showInfo('Career updated successfully'));
          this.props.dispatch(closeAllModals());
          window.location.reload();
        })
        .catch((err) => {
          this.setState({ loading: false });
          this.props.dispatch(showError(err));
        });
    };

    handleDescriptionChange = (content) => {
      this.setState({ description: content });
    };

    render() {
      const open = this.props.open;
      console.log(this.state.career);
      return (
        <div>
          <Modal size="lg" isOpen={open} toggle={this.close}>
            <ModalHeader toggle={this.close}>Update Job Listing</ModalHeader>
            <ModalBody>
              {this.state.errors.length > 0 ? (
                <ul>
                  {this.state.errors.map((error, index) => (
                    <li key={index} style={{ color: 'red' }}>
                      {error}
                    </li>
                  ))}
                </ul>
              ) : (
                ''
              )}
              <form>
                <div>
                  <FormGroup>
                    <Label className="mt-3">Title:</Label>
                    <Input
                      name="title"
                      type="text"
                      onChange={this.setInput}
                      value={this.state.career.title}
                      disabled={this.state.loading}
                    />
                  </FormGroup>

                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <Label for="type">Status</Label>
                        <Input
                          id="status"
                          name="status"
                          type="select"
                          onChange={this.setInput}
                          value={this.state.career.status}
                        >
                          <option value={''}>Please select</option>
                          {this.state.statuses.map((status, index) => (
                            <option
                              key={index}
                              value={status.toLocaleLowerCase()}
                            >
                              {startCase(status)}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md={6} xs={12}>
                      <FormGroup>
                        <Label for="team">Team</Label>
                        <Input
                          id="team"
                          name="team"
                          type="select"
                          onChange={this.setInput}
                          value={this.state.career.team}
                        >
                          <option value={''}>Please select</option>
                          {this.state.teams.map((type, index) => (
                            <option
                              key={index}
                              value={type.toLocaleLowerCase()}
                            >
                              {startCase(type)}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md={12} xs={12}>
                      <FormGroup>
                        <Label className="mt-3">Excerpt:</Label>
                        <Input
                          name="excerpt"
                          type="textarea"
                          onChange={this.setInput}
                          value={this.state.career.excerpt}
                          disabled={this.state.loading}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={12} xs={12}>
                      <FormGroup>
                        <Label className="mt-3">Job Description:</Label>
                        <ReactQuill
                          theme="snow"
                          value={this.state.career.description}
                          onChange={(content) =>
                            this.setInput({
                              target: { name: 'description', value: content },
                            })
                          }
                          readOnly={this.state.loading}
                          modules={{
                            toolbar: [
                              [{ header: [1, 2, 3, false] }],
                              ['bold', 'italic', 'underline', 'strike'],
                              [{ list: 'ordered' }, { list: 'bullet' }],
                              [{ indent: '-1' }, { indent: '+1' }],
                              ['link'],
                              ['clean'],
                              ['image'],
                              ['code-block'],
                              ['blockquote'],
                              ['code'],
                            ],
                          }}
                          placeholder="Write the job description here..."
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </form>
            </ModalBody>
            <ModalFooter>
              <Button
                color="success"
                disabled={this.state.loading}
                onClick={this.updateCareer}
              >
                Update Career{' '}
                {this.state.loading ? (
                  <span className="fas fa-spinner fa-spin"></span>
                ) : (
                  ''
                )}
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
  }
);
